import * as Func from "../helpers/functions";
import * as RateService from './../services/rateService';
import * as Types from '../constants/Types';

import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import {all, call, delay, fork, put, takeEvery, takeLatest} from 'redux-saga/effects';
import { setListRates as setListRatesAction, setListRatesByHotels, setPriceConfigBeachVilla, setRate as setRateAction, setSyncRateLanguage, setSyncRates } from './../actions/rateAction';

import { get } from 'lodash';
import history from '../helpers/history';
import i18n from '../constants/initLng';

function* setListRateSaga() {
    yield takeLatest(Types.RATE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(RateService.getRates, action.filters);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(setListRatesAction(result));
    }, errorHandleRate(Types.RATE_LIST_FAIL)))
}

function* setRateSaga() {
    yield takeLatest(Types.RATE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RateService.getRateDetail, action.id);
        yield put(setRateAction(result));
    }, errorHandleRate(Types.RATE_DETAIL_FAIL)))
}

// TRANSLATE
function* createRateTranslate() {
    yield takeLatest(Types.RATE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.createRateTranslate, action.rate);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.rate.translate.languageName);
        yield put({ type: Types.RATE_CREATE_TRANSLATE_SUCCESS });
        if (action.targetLanguages && action.targetLanguages.length > 0) {
            yield call(RateService.autoTransalate, {
                sourceId: action.rate.id,
                sourceLanguage: 'vi-VN',
                targetLanguages: action.targetLanguages,
            });
            Func.sagaSuccessMessage(action, i18n.t('notification.autoTranslateSuccess'));
        }
        yield put({ type: Types.RATE_DETAIL_ACTION, id: action.rate.id });
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* updateRateTranslate() {
    yield takeLatest(Types.RATE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        const payload = {
            rate: action.rate,
            language: action.language,
        }
        yield call(RateService.updateRateTranslate, payload);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.rate.translate.languageName);
        yield put({ type: Types.RATE_UPDATE_TRANSLATE_SUCCESS });
        if (action.targetLanguages && action.targetLanguages.length > 0) {
            yield call(RateService.autoTransalate, {
                sourceId: action.rate.id,
                sourceLanguage: 'vi-VN',
                targetLanguages: action.targetLanguages,
            });
            Func.sagaSuccessMessage(action, i18n.t('notification.autoTranslateSuccess'));
        }
        yield put({ type: Types.RATE_DETAIL_ACTION, id: action.rate.id });
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* deleteRateTranslate() {
    yield takeLatest(Types.RATE_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.deleteRateTranslate, action.rate.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.rate.translate.languageName);
        yield put({ type: Types.RATE_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.RATE_DETAIL_ACTION, id: action.rate.id });
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* sortRate() {
    yield takeLatest(Types.RATE_SORT_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RateService.sortRate, action.rates);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.RATE_SORT_SUCCESS })
        if(result.status === 200) {
            yield put({ type: Types.RATE_LIST_ACTION, filters: action.filters });
        }
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* syncRatesAllHotels() {
    yield takeLatest(Types.RATE_SYNC_ALL_HOTELS_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.syncRatesAllHotels);
        Func.sagaSuccessMessage(action, i18n.t('validation.syncSuccess'));
        yield put({ type: Types.RATE_SYNC_ALL_HOTELS_SUCCESS })
    }, errorHandleRate(Types.RATE_FAIL)))
}


function* syncRates() {
    yield takeLatest(Types.RATE_SYNC_RATES_ACTION, Func.sagaWrapper(function* (action) {
        const payload = {
            hotelId: action?.hotelId, 
            rateCodes: action?.rateCodes.length ? action?.rateCodes : undefined
        }
        const result = yield call(RateService.syncRatesAll, payload);
        Func.sagaSuccessMessage(action, i18n.t('validation.syncSuccess'));
        yield put (setSyncRates(result));
        // yield put({ type: Types.RATE_SYNC_RATES_SUCCESS })
        if(action.isRefresh && result.status === 200) {
            yield put({ type: Types.RATE_LIST_ACTION, filters: { hotelId: action.hotelId } })
        }
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* setListRateByHotelsSaga() {
    yield takeEvery(Types.RATE_LIST_BY_HOTELS_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RateService.getRatesByHotels, action.filters);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(setListRatesByHotels(result));
    }, errorHandleRate(Types.RATE_LIST_BY_HOTELS_FAIL)))
}

//cancel policy
function* updateCancelPolicy() {
    yield takeLatest(Types.CANCEL_POLICY_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.updateCancelPolicy, action.cancelPolicys);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.CANCEL_POLICY_UPDATE_SUCCESS });
        const result = yield call(RateService.getRateDetail, action.id);
        yield put(setRateAction(result));
    }, errorHandleRate(Types.CANCEL_POLICY_FAIL)))
}

function* syncCancelPolicy() {
    yield takeLatest(Types.CANCEL_POLICY_SYNC_ACTION, Func.sagaWrapper(function* (action) {
        const res  = yield call(RateService.syncCancelPolicy, action.cancelPolicys);
        if(res.status === 200){
            if(res.data && res.data.data){
                Func.sagaSuccessMessage(action, i18n.t('validation.syncDifferentDataCancelPolicy'));
            }else{
                Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
            }
        }
        yield put({ type: Types.CANCEL_POLICY_SYNC_SUCCESS });
        const result = yield call(RateService.getRateDetail, action.id);
        yield put(setRateAction(result));
    }, errorHandleRate(Types.CANCEL_POLICY_FAIL)))
}

function* updateRateActive() {
    yield takeLatest(Types.RATE_UPDATE_ACTIVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.updateRateActive, action.obj.res);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.obj.name);
        yield put({ type: Types.RATE_UPDATE_ACTIVE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.RATE_LIST_ACTION, filters: action.obj.filters });
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* updateRateExtend() {
    yield takeLatest(Types.RATE_UPDATE_EXTEND_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.updateRateExtend, action.obj.res);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.obj.name);
        yield put({ type: Types.RATE_UPDATE_EXTEND_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.RATE_LIST_ACTION, filters: action.obj.filters });
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* syncRateLanguage() {
    yield takeLatest(Types.SYNC_RATE_LANGUAGE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.syncRateLanguage, action.obj.res);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.obj.name);
        yield put({ type: Types.SYNC_RATE_LANGUAGE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.RATE_LIST_ACTION, filters: action.obj.filters });
    }, errorSyncRateLanguage(Types.SYNC_RATE_LANGUAGE_FAIL)))
}

function* updateUsageStatus() {
    yield takeLatest(Types.RATE_USAGE_STATUS_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.updateUsageStatus, action.rates);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.RATE_USAGE_STATUS_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.RATE_LIST_ACTION, filters: action.filters });
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* createRateBeachVilla() {
    yield takeLatest(Types.RATE_BEACH_VILLA_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const payload = {
            id: action.id,
            rate: action.rate,
        }
        yield call(RateService.createRateBeachVilla, payload);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'));
        yield put({ type: Types.RATE_BEACH_VILLA_CREATE_SUCCESS });
        history.push(Func.getPathWithParams(PATHS.RATE.LIST.path, { hotel_id: action.id }));
        history.go();
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* getPriceConfigBeachVilla () {
    yield takeLatest(Types.PRICE_CONFIG_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const payload = {
            hotelId: action.filters.hotelId,
            ratePlanId: action.filters.ratePlanId,
            pageSize: 1000,
        }
        const result = yield call(RateService.getPriceConfigBeachVilla, payload);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(setPriceConfigBeachVilla(result));
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* createPriceConfigBeachVilla() {
    yield takeLatest(Types.PRICE_CONFIG_BEACH_VILLA_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.createPriceConfigBeachVilla, action.data);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'));
        yield put({ type: Types.PRICE_CONFIG_BEACH_VILLA_CREATE_SUCCESS });
        yield put({
            type: Types.PRICE_CONFIG_LIST_ACTION,
            filters: {
                hotelId: action.data.hotelId,
                ratePlanId: action.data.ratePlanId,
            }
        });
    }, errorHandleRate(Types.RATE_FAIL)))
}

function* updatePriceConfigBeachVilla() {
    yield takeLatest(Types.PRICE_CONFIG_BEACH_VILLA_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateService.updatePriceConfigBeachVilla, action.data);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.PRICE_CONFIG_BEACH_VILLA_UPDATE_SUCCESS });
        yield put({
            type: Types.PRICE_CONFIG_LIST_ACTION,
            filters: {
                hotelId: action.data.hotelId,
                ratePlanId: action.data.ratePlanId,
            }
        });
    }, errorHandleRate(Types.RATE_FAIL)))
}

function errorHandleRate(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'rate');
}

function errorSyncRateLanguage(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType, data: get(e, 'request')})
    }, 'rate', false);
}

export function* rateSaga() {
    yield all([
        fork(setListRateSaga),
        fork(setRateSaga),
        fork(createRateTranslate),
        fork(updateRateTranslate),
        fork(deleteRateTranslate),
        fork(sortRate),
        fork(syncRatesAllHotels),
        fork(syncRates),
        fork(setListRateByHotelsSaga),
        fork(updateCancelPolicy),
        fork(syncCancelPolicy),
        fork(updateRateActive),
        fork(updateUsageStatus),
        fork(syncRateLanguage),
        fork(updateRateExtend),
        fork(createRateBeachVilla),
        fork(getPriceConfigBeachVilla),
        fork(createPriceConfigBeachVilla),
        fork(updatePriceConfigBeachVilla),
    ])
}
